// TabTitle — reflect total highlight (mention) count in document.title.
//
// Rule (design brief § Tab title):
//   - `highlight > 0`: `(N) Nurion Chat`
//   - otherwise:       `Nurion Chat`
//   - No sound. No flashing.
//
// The component is an effect-only surface — it renders `null` but
// writes to `document.title` on mount and on every `highlight`
// change. Stories exercise the same effect and pick the current
// title up via a visible debug readout below.

import { useEffect } from "react";

const BASE_TITLE = "Nurion Chat";

export interface TabTitleProps {
  highlight: number;
}

export function TabTitle({ highlight }: TabTitleProps) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    const next = highlight > 0 ? `(${highlight}) ${BASE_TITLE}` : BASE_TITLE;
    if (document.title !== next) document.title = next;
  }, [highlight]);
  return null;
}

/** Exposed so the story can render the same logic without a DOM
 *  write. Shared with `TabTitle` above so a single source of truth
 *  governs the format string. */
export function formatTabTitle(highlight: number): string {
  return highlight > 0 ? `(${highlight}) ${BASE_TITLE}` : BASE_TITLE;
}
